// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const base = 'https://psp.policia.gob.do';

export const environment = {
  production: false,
  baseUrlImage: base + ':8443',
  baseURL: base + ':8081/api',
  // ApiService
  baseURLService: 'https://api.ulticabinet.com',
  apiKey: '301a7e37-264c-4ec6-89bd-011586e33958',
  clientId: '56aed9e5-655b-4203-a978-4cbe826591c4',
  userId: 'PSP',
  password: 'Policia1936@'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
